export default "<app-service-box  [Lists]=\"Lists\" [titleSectionProp]=\"titleSectionProp\"></app-service-box>\n"